import { paymentQueryNames } from '@/entities/payment';

export const FISCAL_MUTATION_OPTIONS = {
  context: { suppressGlobalErrorToast: true },
};

export function createFiscalPaymentMutationOptions() {
  return { ...FISCAL_MUTATION_OPTIONS, refetchQueries: [...paymentQueryNames] };
}
